<div class=" z-40 bg-white  py-2 fixed top-0  w-full transition-colors duration-500 ease-in-out" [ngClass]="{ 'bg-white shadow': isScrolled, 'shadow-none': !isScrolled }">
    <div class="text-black">
        <div class=" md:px-11 grid grid-cols-12 items-center">
            <div class="col-span-6 sm:col-span-2">
                <img [routerLink]="'/'" src="assets/image/header-img/white-volmint-logo.png" alt="Logo" class="w-[150px] md:w-48"/>
            </div>

            <div class="col-span-6 sm:hidden flex justify-end pr-4">
                <button (click)="toggleMobileMenu()" class="text-gray-700 text-2xl focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                         class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 6h16M4 12h16m-7 6h7"/>
                    </svg>
                </button>
            </div>
            <div class="col-span-10 hidden sm:flex menu items-center justify-end py-2">
                <div class="flex gap-6 px-5">
                    <button class="bg-background hover:bg-white px-8 py-3 "><a href="tel:+91 9310828501" class="text-white  text-sm font-bold  ">Call Now</a></button>
                    <button class="bg-background hover:bg-white px-8 py-3 " (click)="openModal()"><a  class=" text-white cursor-pointer  text-sm font-bold">Book a Free Session</a></button>
                </div>
            </div>
        </div>
    </div>
</div>


<div
    class="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-end sm:hidden"
    *ngIf="isMobileMenuOpen"
>
    <div class="bg-white w-2/3 h-full transform transition-transform duration-300 ease-in-out"
         [ngClass]="{'translate-x-0': isMobileMenuOpen, 'translate-x-full': !isMobileMenuOpen}">
        <div class="p-4">
            <button (click)="toggleMobileMenu()" class="text-gray-700 text-2xl focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                     class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>
        <div class=" p-4">
            <button class="bg-background hover:bg-white px-8 py-3 mb-4"><a href="tel:+91 9310828501" class="text-white  text-sm font-bold  ">Call Now</a></button>
            <button class="bg-background hover:bg-white px-8 py-3 " (click)="openModal()"><a  class=" text-white cursor-pointer  text-sm font-bold">Book a Free Session</a></button>
        </div>
    </div>
</div>


<div *ngIf="isModalOpen"
     class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 transition-opacity duration-500"
     [ngClass]="{'opacity-100': isModalVisible, 'opacity-0': !isModalVisible}"
     (transitionend)="onTransitionEnd()">
    <div class="rounded-lg shadow-lg w-[90%] md:w-[50%] transform transition-all duration-500 ease-in-out"
         [ngClass]="{'scale-100 opacity-100 translate-y-0': isModalVisible, 'scale-95 opacity-0 translate-y-10': !isModalVisible}">

        <!-- Modal Header -->
        <div class="bg-background flex justify-between items-center rounded-t-lg px-4 py-3">
            <h2 class="text-xl text-white font-semibold">Book a Free Demo</h2>

            <a (click)="closeModal()"
                    class="text-white text-xl px-4 py-2 rounded hover:text-red-600">
                <i class="fa fa-close"></i>
            </a>
        </div>

        <div class="bg-white p-6 rounded-b-lg">
            <app-form (formSubmitted)="formSubmission($event)"></app-form>
        </div>
    </div>
</div>
